import { BALANCE_TICKET } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IBalanceHistoryRepository } from "features/balanceHistory/domain/repositories/IBalanceHistoryRepository";
import { injectable } from "tsyringe";
import { CreateBalanceTicketRequestModel } from "./model/actions/CreateBalanceTicketRequestModel";
import { UpdateBalanceTicketRequestModel } from "./model/actions/UpdateBalanceTicketRequestModel";
import { BalanceHistoryRequestModel } from "./model/BalanceHistoryRequestModel";
import { BalanceHistoryResponseModel } from "./model/BalanceHistoryResponseModel";
import { BalanceHistoryDetailResponseModel } from "./model/details/BalanceHistoryDetailResponseModel";
import { TransactionForRefundRequestModel } from "./model/transactionForRefund/TransactionForRefundRequestModel";
import { TransactionForRefundResponseModel } from "./model/transactionForRefund/TransactionForRefundResponseModel";

@injectable()
export class BalanceHistoryImpl implements IBalanceHistoryRepository {
  async getList(
    params: BalanceHistoryRequestModel,
  ): Promise<ListBaseApiResponseModel<BalanceHistoryResponseModel>> {
    return await client?.get(BALANCE_TICKET?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<BalanceHistoryDetailResponseModel>> {
    return await client?.get(BALANCE_TICKET?.DETAIL, params);
  }

  async getTransactionForRefund(
    params: TransactionForRefundRequestModel,
  ): Promise<ListBaseApiResponseModel<TransactionForRefundResponseModel>> {
    return await client?.get(BALANCE_TICKET.TRANSLISTFORREFUND, params);
  }

  async updateTicket(
    body: UpdateBalanceTicketRequestModel,
  ): Promise<BaseApiResponseModel<BalanceHistoryDetailResponseModel>> {
    return await client?.put(BALANCE_TICKET?.UPDATE, body);
  }

  async createTicket(
    body: CreateBalanceTicketRequestModel,
  ): Promise<BaseApiResponseModel<BalanceHistoryDetailResponseModel>> {
    return await client?.post(BALANCE_TICKET?.CREATE, body);
  }
}
